import DashboardContainer from '../DashboardContainer';
import { TimesheetModalsProvider } from './components/TimesheetModalsProvider';

interface TimesheetsContainerLayoutProps {
  children: React.ReactNode;
}

export function TimesheetsContainerLayout({ children }: TimesheetsContainerLayoutProps) {
  return (
    <DashboardContainer showSecondaryNav>
      <TimesheetModalsProvider>{children}</TimesheetModalsProvider>
    </DashboardContainer>
  );
}
